import styled from 'styled-components';
import { VerticalContainer } from "../../../components/Common/CommonLayout";

const BodyContainer = styled(VerticalContainer)`
    padding: 3em;
    & .ml-1 {
        margin-left: 1em
    }
    & .mb-2 {
        margin-bottom: 2em;
    }
    & .mt-2 {
        margin-top: 2em;
    }
`;

export {
    BodyContainer
};
